import type { AchievementUnlockParams } from "../types";
import type { Transport } from "../transport";

/**
 * Достижения (ачивки). Разраб создаёт их в `/dev/games/[id]/achievements`
 * (id, название, описание, иконка, опционально прогресс-шкала).
 *
 * Игра вызывает unlock() когда достижение достигнуто. Платформа показывает
 * анимированный toast игроку, записывает в его профиль `/profile/achievements`.
 */
export function createAchievements(t: Transport) {
  return {
    /**
     * Разблокировать ачивку. Если уже разблокирована — no-op.
     * Для ачивок с прогрессом — передавай текущее значение:
     *   `unlock({ id: "100_coins", progress: 42 })`
     * Когда progress достигнет target-значения — ачивка разблокируется автоматически.
     */
    unlock(params: AchievementUnlockParams): Promise<{
      unlocked: boolean;
      firstTime: boolean;
      progress?: { current: number; target: number };
    }> {
      return t.request("achievements.unlock", params);
    },

    /**
     * Получить список разблокированных ачивок текущего юзера для этой игры.
     */
    list(): Promise<Array<{ id: string; unlockedAt: string }>> {
      return t.request("achievements.list");
    },
  };
}

export type AchievementsApi = ReturnType<typeof createAchievements>;
